import { Mutations, Actions, Module } from 'vuex-smart-module'

import { loading as loadingModule, LoadingGetters } from '@/store/modules/loading'
import { DaDataService } from '@/api'

const loading = loadingModule.clone()

class DaDataState {}

class DaDataGetters extends LoadingGetters<DaDataActions, DaDataState> {
  get isAddressesGet() {
    return this.state.loading.loaders.getAddresses
  }

  get isFmsUnitsGet() {
    return this.state.loading.loaders.getFmsUnits
  }
}

class DaDataMutations extends Mutations<DaDataState> {}

class DaDataActions extends Actions<DaDataState, DaDataGetters, DaDataMutations, DaDataActions> {
  async getAddresses(query: string) {
    const { list } = await DaDataService.getAddressSuggestions(query)
    return list
  }

  async getFmsUnits(code: string) {
    const { list } = await DaDataService.getFmsUnitSuggestions(code)
    return list
  }
}

export type DaDataModules = {
  loading: typeof loading
}

export const dadata = new Module<DaDataState, DaDataGetters, DaDataMutations, DaDataActions, DaDataModules>({
  modules: { loading },
  state: DaDataState,
  getters: DaDataGetters,
  mutations: DaDataMutations,
  actions: DaDataActions,
})
